import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getMe, logoutAdmin, verifyEmployee, logoutEmployee } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await getMe();
      setUser(res.data);
    } catch {
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = (_token, userData) => {
    setUser(userData);
  };

  const logout = async () => {
    try { await logoutAdmin(); } catch { /* ignore */ }
    setUser(null);
    // Clear theme to prevent style leakage to login page
    localStorage.removeItem("theme");
    document.documentElement.classList.remove("dark");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}

// Employee portal auth
const EmpAuthContext = createContext(null);

export function EmpAuthProvider({ children }) {
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await verifyEmployee();
        setEmployee(res.data.employee);
      } catch {
        setEmployee(null);
      }
      setLoading(false);
    };
    check();
  }, []);

  const login = (_token, empData) => {
    setEmployee(empData);
  };

  const logout = async () => {
    try { await logoutEmployee(); } catch { /* ignore */ }
    setEmployee(null);
    localStorage.removeItem("theme");
    document.documentElement.classList.remove("dark");
  };

  return (
    <EmpAuthContext.Provider value={{ employee, login, logout, loading }}>
      {children}
    </EmpAuthContext.Provider>
  );
}

export function useEmpAuth() {
  const ctx = useContext(EmpAuthContext);
  if (!ctx) throw new Error("useEmpAuth must be inside EmpAuthProvider");
  return ctx;
}
